import axiosConfig from "../../config/axios"

export const createCompany = payload => {
  return axiosConfig({
    url: `/companies/`,
    data: payload,
    method: "POST"
  })
}

export const updateCompany = (companyId, payload) => {
  return axiosConfig({
    url: `/companies/${companyId}/`,
    data: payload,
    method: "PATCH"
  })
}

export const updateCompanyImage = (companyId, blob, fileName) => {
  const formdata = new FormData()
  formdata.append("logo", blob, fileName)

  return axiosConfig({
    url: `/companies/${companyId}/`,
    data: formdata,
    method: "PATCH"
  })
}

export const getCompanyById = (id) => {
  return axiosConfig({
    url: `/companies/${id}`,
    method: "GET",
  })
}

export const getCompanies = (limit, offset, params, is_active = true) => {
  return axiosConfig({
    url: `/companies/`,
    method: "GET",
    params: {
      limit: limit,
      offset: offset,
      is_active: is_active,
      ...params
    }
  })
}

export const getFilterCompanies = params => {
  return axiosConfig({
    url: `/companies/`,
    method: "GET",
    params: {
      type: "filter",
      ordering: "-is_active",
      ...params
    }
  })
}

export function getCompaniesMinimal(isActive, all = false) {
  // * Get list of companies with minimal data i.e. name and id.
  // This is used in dropdowns/selects.
  const params = all ? null : { is_active: isActive }
  return axiosConfig({
    url: `/companies/list/`,
    method: "GET",
    params: params
  })
}

export const getMemberships = () => {
  return axiosConfig({
    url: `/memberships/`,
    method: "GET"
  })
}

export const deleteCompany = (companyId) => {
  return axiosConfig.delete(`/companies/${companyId}/`)
}
